/**
 * search_suggestion_card.js
 * -------------------------
 * How the store search suggestions render their <fragno-offer-card>: which size to use at the
 * current screen width, and the CSS that lets the text wrap. Shared by the nav overlay
 * (shop_nav_wiring.js) and the search bar (shop-search-bar.js) so the two stay in step.
 */

// Width at or below which the suggestions use the "xs" card.
const COMPACT_QUERY = "(max-width: 30rem)";

function compactQuery() {
  return typeof window.matchMedia === "function"
    ? window.matchMedia(COMPACT_QUERY)
    : null;
}

/** Phones get fragno's smaller "xs" card (smaller logo, button and padding); the rest get "sm". */
export function suggestionCardSize() {
  return compactQuery()?.matches ? "xs" : "sm";
}

/**
 * Calls `onChange(size)` whenever the screen crosses the compact width, so cards already on the
 * page can follow a resize or rotation. Returns a function that stops watching.
 */
export function watchSuggestionCardSize(onChange) {
  const query = compactQuery();
  if (!query) return () => {};
  const listener = () => onChange(suggestionCardSize());
  query.addEventListener("change", listener);
  return () => query.removeEventListener("change", listener);
}

/**
 * CSS that makes the card's text wrap instead of truncating, for cards under `scope` (a
 * selector). fragno sizes the card body to zero, caps the "xs" card at 102px and clamps the
 * title to two lines, which would clip or overlap long names and offers. This lets the body size
 * to its content (the card grows past its min-height) and lifts the caps. The subtitle may be
 * a long offer headline, so it breaks anywhere rather than overflowing.
 */
export function suggestionCardWrapCss(scope) {
  const card = `${scope} .fragno-offer-card:is([data-size="xs"], [data-size="sm"])`;
  return `
    ${card} {
      max-height: none;
    }
    ${scope} .fragno-offer-card__content,
    ${card} .fragno-offer-card__bottom {
      flex: 1 0 auto;
    }
    ${card} .fragno-offer-card__title {
      display: block;
      max-height: none;
      overflow: visible;
      -webkit-line-clamp: unset;
      line-clamp: none;
      overflow-wrap: anywhere;
    }
    ${scope} .fragno-offer-card__subtitle {
      overflow-wrap: anywhere;
    }
  `;
}
